module.exports = __webpack_public_path__ + "img/banner-font.5225b43e.png";